import { render } from "./QuestionAnswers.vue?vue&type=template&id=5cc15be6&scoped=true"
import script from "./QuestionAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionAnswers.vue?vue&type=script&lang=js"

import "./QuestionAnswers.vue?vue&type=style&index=0&id=5cc15be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc15be6"]])

export default __exports__